import { Modal, Grid, Text } from '@simplywallst/ui-core';

const InformationModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <Modal
      title="Portfolio Snowflake"
      onSecondaryClick={onClose}
      secondaryLabel="Close"
    >
      <Grid gap="16px">
        <Text color="inherit" typography="xSmall">
          The Portfolios Snowflake chart offers a unified snapshot of the
          collective fundamental scores across all your portfolios, providing a
          comprehensive overview of all your investments.
        </Text>
      </Grid>
    </Modal>
  );
};

export default InformationModal;
